import { Component, OnInit, AfterViewInit, OnDestroy, NgZone } from '@angular/core';
import { MapService } from '../services/map.service';
import { toLonLat } from 'ol/proj';
import { LatLonDMS } from '../models/coord-dms';
import { CoordenateService } from '../services/coordenate.service';
import { ToolsControlService } from '../services/tools-control.service';
import { ConfigurationService } from '../services/configuration.service';
import { firstValueFrom } from 'rxjs';
import { AppComponent } from '../app.component';
import { IdentifyToolService } from '../services/identify-tool.service';
import { SelectByFirComponent } from '../popup/select-by-fir/select-by-fir.component';
import { TerrainHeightService } from './services/terrain-height.service';
import { DistanceAzimuthService } from './services/distance-azimuth.service';
import { TerrainAltitudeCutService } from '../services/terrain-altitude-cut.service';
import { EventListenersOnMap } from '../utils/eventListenersOnMap';
//import { TabsService } from '../services/tabsService';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  standalone: false
})
export class MapComponent implements OnInit, AfterViewInit, OnDestroy {

  showWatermark = true;

  map: any = {};
  private intervalId: any;

  constructor(
    public mapService: MapService,
    private rcsControl: CoordenateService,
    public toolsService: ToolsControlService,
    //public tabsService: TabsService
    private configurationService: ConfigurationService,
    private ngZone: NgZone
  ) {}



  ngOnInit() {
    this.map = this.mapService.getMap('map');
  }

  ngAfterViewInit() {
    this.updateWatermarkPositionHorizontal();
    this.updateWatermarkPositionVertical();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateWatermarkPositionHorizontal() {
    setTimeout(() => {
      let leftOffset = 60;
      const stickyMenu = document.querySelector('.sticky-menu');
      if (stickyMenu) {
        const menu = stickyMenu.querySelector('app-menu');
        if (menu) {
          const menuContainer = menu.querySelector('.menu__container');
          if (menuContainer) {
            const activeMenuItems = Array.from(menuContainer.querySelectorAll('.menu__item.active'));
            const hasCalculationResults = activeMenuItems.some(item => item.classList.contains('calculation-results'));
            if (hasCalculationResults) {
              if (activeMenuItems.length > 1) {
                leftOffset = 370;
              } else {
                leftOffset = 60;
              }
            } else if (activeMenuItems.length > 0) {
              leftOffset = 370;
            } else {
              leftOffset = 60;
            }
          }
        }
      }
      document.documentElement.style.setProperty('--watermark-left', leftOffset + 'px');
    }, 0);
  }

  updateWatermarkPositionVertical() {
    const stableSub = this.ngZone.onStable.asObservable().subscribe(() => {
      let bottomOffset = 5;
      const appFooter = document.querySelector('app-footer');
      if (appFooter) {
        // .bottom-menu.open-menu.active.fullscreen = hide watermark
        const fullscreenFooter = appFooter.querySelector('.bottom-menu.active.fullscreen');
        if (fullscreenFooter) {
          this.showWatermark = false;
          bottomOffset = 0;
        } else {
          this.showWatermark = true;
          // .bottom-menu.active.minimized = 30px
          const activeFooter = appFooter.querySelector('.bottom-menu.active');
          if (activeFooter) {
            if (activeFooter.classList.contains('minimized')) {
              bottomOffset = 30;
            } else {
              bottomOffset = 495;
            }
          } else {
            bottomOffset = 5;
          }
        }
      } else {
        this.showWatermark = true;
      }
      document.documentElement.style.setProperty('--footer-height', bottomOffset + 'px');
      stableSub.unsubscribe();
    });
  }



    displayCloseEventsButton(): boolean {
      return (
        EventListenersOnMap.hasEvent(IdentifyToolService.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(SelectByFirComponent.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(TerrainHeightService.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(DistanceAzimuthService.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL)
      );
    }

}
